<template>
  <div class="header-nav">
    <header :class="headerClasses">
      <div class="container">
        <div class="header-shell">
          <router-link to="/" class="brand-link" @click.native="closeMenu">
            <div class="brand-mark">
              <img src="/images/logo2.png" alt="公司logo" class="logo-image" />
            </div>
            <div class="brand-copy">
              <div class="brand-topline">
                <span class="brand-title brand-title-desktop">东莞市恒源造纸新材料有限公司</span>
                <span class="brand-title brand-title-mobile">恒源造纸新材料</span>
                <span class="brand-badge">Eco-Source · Since 2004</span>
              </div>
              <span class="brand-subtitle">Dongguan Hengyuan Papermaking New Materials Co., Ltd.</span>
            </div>
          </router-link>

          <nav class="nav-desktop" aria-label="主导航">
            <ul class="nav-list">
              <li v-for="item in navItems" :key="item.to" class="nav-item">
                <router-link
                  :to="item.to"
                  :exact="item.exact"
                  class="nav-link"
                  :class="{ 'is-active': isActiveRoute(item) }"
                >
                  <span class="nav-icon"><i :class="item.icon"></i></span>
                  <span>{{ item.label }}</span>
                </router-link>
              </li>
            </ul>
          </nav>

          <button
            type="button"
            class="mobile-menu-btn"
            :aria-expanded="showMobileMenu ? 'true' : 'false'"
            aria-label="切换导航菜单"
            @click="toggleMenu"
          >
            <span class="mobile-menu-icon">
              <i :class="showMobileMenu ? 'el-icon-close' : 'el-icon-menu'"></i>
            </span>
          </button>
        </div>
      </div>
    </header>

    <transition name="mobile-menu-fade">
      <div v-if="showMobileMenu" class="mobile-menu" @click="closeMenu">
        <div class="mobile-menu-mask"></div>
        <aside class="mobile-menu-content" @click.stop>
          <div class="mobile-menu-top">
            <div class="mobile-menu-brand">
              <div class="mobile-menu-brand-title">恒源造纸新材料</div>
              <div class="mobile-menu-brand-subtitle">Papermaking New Materials</div>
            </div>
            <button type="button" class="mobile-menu-close" aria-label="关闭菜单" @click="closeMenu">
              <i class="el-icon-close"></i>
            </button>
          </div>

          <div class="mobile-menu-tip">专注造纸新材料解决方案与客户服务</div>

          <ul class="mobile-nav-list">
            <li v-for="item in navItems" :key="`mobile-${item.to}`" class="mobile-nav-item">
              <router-link
                :to="item.to"
                :exact="item.exact"
                class="mobile-nav-link"
                :class="{ 'is-active': isActiveRoute(item) }"
                @click.native="closeMenu"
              >
                <span class="mobile-nav-icon"><i :class="item.icon"></i></span>
                <span class="mobile-nav-label">{{ item.label }}</span>
                <i class="el-icon-arrow-right mobile-nav-arrow"></i>
              </router-link>
            </li>
          </ul>
        </aside>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'HeaderNav',
  data() {
    return {
      showMobileMenu: false,
      isScrolled: false,
      navItems: [
        { to: '/', label: '首页', icon: 'el-icon-s-home', exact: true },
        { to: '/product', label: '产品中心', icon: 'el-icon-goods' },
        { to: '/about', label: '关于我们', icon: 'el-icon-user' },
        { to: '/contact', label: '联系我们', icon: 'el-icon-phone' }
      ]
    };
  },
  computed: {
    headerClasses() {
      return {
        header: true,
        'header--scrolled': this.isScrolled
      };
    }
  },
  watch: {
    '$route.path'() {
      this.closeMenu();
      this.$nextTick(() => {
        this.updateScrollState();
      });
    }
  },
  methods: {
    isActiveRoute(item) {
      if (!this.$route) {
        return false;
      }

      if (item.exact) {
        return this.$route.path === item.to;
      }

      return this.$route.path === item.to || this.$route.path.indexOf(`${item.to}/`) === 0;
    },
    toggleMenu() {
      this.showMobileMenu = !this.showMobileMenu;
      document.body.style.overflow = this.showMobileMenu ? 'hidden' : '';
    },
    closeMenu() {
      this.showMobileMenu = false;
      document.body.style.overflow = '';
    },
    updateScrollState() {
      this.isScrolled = window.scrollY > 18;
    },
    handleResize() {
      if (window.innerWidth > 1024 && this.showMobileMenu) {
        this.closeMenu();
      }
    }
  },
  mounted() {
    this.updateScrollState();
    window.addEventListener('scroll', this.updateScrollState, { passive: true });
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    document.body.style.overflow = '';
    window.removeEventListener('scroll', this.updateScrollState);
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
.header-nav {
  position: relative;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  padding: 8px 0 0;
  pointer-events: none;
  transition: padding 0.35s ease;
}

.header--scrolled {
  padding-top: 4px;
}

.container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
}

.header-shell,
.mobile-menu,
.mobile-menu-content {
  pointer-events: auto;
}

.header-shell {
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
  isolation: isolate;
  --header-text-color: #183b78;
  --header-subtext-color: #5e7398;
  --header-soft-surface: rgba(25, 69, 140, 0.08);
  min-height: 84px;
  padding: 8px 18px 8px 16px;
  border-radius: 24px;
  border: none;
  overflow: hidden;
  transition: transform 0.35s ease, min-height 0.35s ease, padding 0.35s ease, box-shadow 0.35s ease;
}

.header--scrolled .header-shell {
  min-height: 76px;
  padding-top: 6px;
  padding-bottom: 6px;
}

.brand-link {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  flex: 1 1 auto;
}

.brand-link:hover {
  color: inherit;
}

.brand-mark {
  width: 100px;
  height: 100px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 22px;
  //background: linear-gradient(180deg, rgba(255, 255, 255, 0.24), rgba(255, 255, 255, 0.1));
  //box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.26), 0 10px 24px rgba(7, 28, 66, 0.1);
}

.logo-image {
  display: block;
  width: auto;
  max-width: 94px;
  max-height: 94px;
}

.brand-copy {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-left: 12px;
}

.brand-topline {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex-wrap: wrap;
}

.brand-title {
  color: var(--header-text-color);
  font-size: 26px;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: 0.02em;
  text-shadow: 0 4px 14px rgba(3, 18, 45, 0.1);
}

.brand-title-mobile {
  display: none;
}

.brand-badge {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  background: var(--header-soft-surface);
  border: 1px solid rgba(255, 255, 255, 0.22);
  color: var(--header-text-color);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
}

.brand-subtitle {
  color: var(--header-subtext-color);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.04em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nav-desktop {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.nav-list {
  display: flex;
  align-items: center;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 2px;
  border-radius: 20px;
  background: transparent;
  border: none;
  box-shadow: none;
}

.nav-item {
  margin: 0;
}

.nav-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 46px;
  padding: 0 14px 0 10px;
  border-radius: 16px;
  color: var(--header-text-color);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.01em;
  background: transparent;
  transition: transform 0.28s ease, background 0.28s ease, color 0.28s ease, box-shadow 0.28s ease;
}

.nav-link:hover {
  color: var(--header-text-color);
  background: var(--header-soft-surface);
  transform: translateY(-1px);
}

.nav-icon {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
  color: inherit;
  font-size: 15px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
  transition: transform 0.22s ease, background 0.22s ease, box-shadow 0.22s ease, color 0.22s ease;
}

.nav-link.is-active {
  color: var(--primary-color, #2f76ff);
  background: transparent;
  box-shadow: none;
  transform: translateY(-1px);
  transition: color 0.22s ease, transform 0.22s ease;
}

.nav-link.is-active .nav-icon {
  background: rgba(47,118,255,0.16);
  color: #ffffff;
  box-shadow: 0 8px 20px rgba(47,118,255,0.10);
  transform: translateY(-1px) scale(1.02);
}

.nav-link.is-active::after {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -8px;
  width: 44%;
  height: 6px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(47, 118, 255, 0.95) 0%, rgba(107, 124, 255, 0.95) 100%);
  box-shadow: 0 10px 30px rgba(47, 118, 255, 0.12);
  opacity: 0.98;
  transition: all 0.28s ease;
}

.nav-link::before,
.nav-item::before,
.nav-item::after,
.nav-link.router-link-active::before,
.nav-item.router-link-active::after {
  content: none !important;
}

.nav-link * {
  background-image: none !important;
}

::v-deep .el-icon-check {
  display: none;
}

.mobile-menu-btn {
  display: none;
  position: relative;
  z-index: 4;
  width: 48px;
  height: 48px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 16px;
  background: var(--header-soft-surface);
  color: var(--header-text-color);
  cursor: pointer;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.12);
  transition: transform 0.28s ease, background 0.28s ease, box-shadow 0.28s ease;
}

.mobile-menu-btn:hover {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 10px 20px rgba(10, 28, 61, 0.08);
}

.mobile-menu-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 22px;
}

.mobile-menu {
  position: fixed;
  inset: 0;
  z-index: 10020;
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
}

.mobile-menu-mask {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: rgba(7, 16, 36, 0.42);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.mobile-menu-content {
  position: relative;
  z-index: 2;
  width: min(360px, 86vw);
  height: 100dvh;
  max-height: 100dvh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  padding: 28px 20px 24px;
  background: linear-gradient(180deg, rgba(247, 250, 255, 0.98) 0%, rgba(238, 244, 255, 0.98) 100%);
  box-shadow: -12px 0 40px rgba(13, 34, 75, 0.18);
  overflow: hidden;
  overscroll-behavior: contain;
  transform: translateX(0);
  transition: transform 0.32s ease, box-shadow 0.32s ease;
  will-change: transform;
}

.mobile-menu-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.mobile-menu-brand-title {
  color: #173f85;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
}

.mobile-menu-brand-subtitle {
  margin-top: 6px;
  color: #6c84ae;
  font-size: 12px;
  letter-spacing: 0.06em;
}

.mobile-menu-close {
  position: relative;
  z-index: 3;
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: 14px;
  background: #ffffff;
  color: #244d98;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(35, 75, 144, 0.12);
}

.mobile-menu-tip {
  margin-top: 18px;
  padding: 12px 14px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(47, 118, 255, 0.1) 0%, rgba(91, 116, 245, 0.12) 100%);
  color: #4d6790;
  font-size: 13px;
  line-height: 1.7;
}

.mobile-nav-list {
  list-style: none;
  margin: 20px 0 0;
  padding: 0;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 2px;
}

.mobile-nav-item + .mobile-nav-item {
  margin-top: 12px;
}

.mobile-nav-link {
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 64px;
  padding: 0 16px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.9);
  color: #234884;
  box-shadow: 0 10px 24px rgba(32, 67, 126, 0.08);
  transition: transform 0.28s ease, box-shadow 0.28s ease, background 0.28s ease, color 0.28s ease;
}

.mobile-nav-link:hover {
  transform: translateX(2px);
  color: #20468b;
}

.mobile-nav-link.is-active {
  color: #ffffff;
  background: linear-gradient(135deg, rgba(47,118,255,0.95) 0%, rgba(88,106,244,0.95) 100%);
  box-shadow: none;
}

.mobile-nav-icon {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: rgba(47, 118, 255, 0.1);
  font-size: 18px;
  flex-shrink: 0;
}

.mobile-nav-link.is-active .mobile-nav-icon {
  background: rgba(255, 255, 255, 0.18);
}

.mobile-nav-label {
  flex: 1;
  font-size: 15px;
  font-weight: 600;
}

.mobile-nav-arrow {
  font-size: 14px;
  opacity: 0.72;
}

.mobile-menu-fade-enter-active,
.mobile-menu-fade-leave-active {
  transition: opacity 0.28s ease;
}

.mobile-menu-fade-enter-active .mobile-menu-mask,
.mobile-menu-fade-leave-active .mobile-menu-mask {
  transition: opacity 0.28s ease;
}

.mobile-menu-fade-enter-active .mobile-menu-content,
.mobile-menu-fade-leave-active .mobile-menu-content {
  transition: transform 0.32s ease, box-shadow 0.32s ease;
}

.mobile-menu-fade-enter,
.mobile-menu-fade-leave-to {
  opacity: 0;
}

.mobile-menu-fade-enter .mobile-menu-mask,
.mobile-menu-fade-leave-to .mobile-menu-mask {
  opacity: 0;
}

.mobile-menu-fade-enter .mobile-menu-content,
.mobile-menu-fade-leave-to .mobile-menu-content {
  transform: translateX(100%);
  box-shadow: none;
}

@media (max-width: 1280px) {
  .brand-title {
    font-size: 22px;
  }

  .brand-badge {
    padding: 0 10px;
  }

  .nav-list {
    gap: 6px;
  }
}

@media (max-width: 1120px) {
  .header-shell {
    gap: 14px;
  }

  .brand-title {
    font-size: 20px;
  }

  .brand-subtitle {
    font-size: 11px;
  }

  .nav-link {
    min-height: 42px;
    padding: 0 12px 0 8px;
    font-size: 14px;
  }
}

@media (max-width: 1024px) {
  .header {
    padding-top: 8px;
  }

  .header-shell {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    min-height: 76px;
    padding: 10px 14px;
    border-radius: 22px;
  }

  .brand-title-desktop,
  .brand-subtitle,
  .brand-badge,
  .nav-desktop {
    display: none;
  }

  .brand-title-mobile {
    display: inline;
    font-size: 24px;
  }

  .brand-link {
    max-width: 100%;
    min-width: 0;
    padding-right: 6px;
  }

  .brand-copy,
  .brand-topline {
    min-width: 0;
    overflow: hidden;
  }

  .brand-title-mobile {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .brand-mark {
    width: 62px;
    height: 62px;
    border-radius: 18px;
  }

  .logo-image {
    max-width: 54px;
    max-height: 54px;
  }

  .mobile-menu-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .mobile-menu-content {
    padding-top: calc(22px + env(safe-area-inset-top, 0px));
    padding-bottom: calc(18px + env(safe-area-inset-bottom, 0px));
  }

  .mobile-menu-top,
  .mobile-menu-tip {
    flex-shrink: 0;
  }
}

@media (max-width: 767px) {
  .container {
    padding: 0 14px;
  }

  .header-shell {
    min-height: 70px;
    gap: 12px;
    padding: 8px 12px;
    border-radius: 20px;
  }

  .brand-link {
    gap: 12px;
    padding-right: 4px;
  }

  .brand-mark {
    width: 54px;
    height: 54px;
    border-radius: 16px;
  }

  .logo-image {
    max-width: 47px;
    max-height: 47px;
  }

  .brand-title-mobile {
    font-size: 20px;
  }

  .mobile-menu-btn {
    width: 46px;
    height: 46px;
    border-radius: 16px;
  }

  .mobile-menu-content {
    width: min(336px, 88vw);
    padding: calc(18px + env(safe-area-inset-top, 0px)) 16px calc(14px + env(safe-area-inset-bottom, 0px));
  }

  .mobile-menu-brand-title {
    font-size: 20px;
  }

  .mobile-menu-tip {
    margin-top: 14px;
    padding: 10px 12px;
    font-size: 12px;
    line-height: 1.6;
  }

  .mobile-nav-list {
    margin-top: 16px;
  }

  .mobile-nav-link {
    min-height: 58px;
    padding: 0 14px;
    border-radius: 18px;
  }

  .mobile-nav-icon {
    width: 36px;
    height: 36px;
    border-radius: 12px;
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 12px;
  }

  .brand-title-mobile {
    font-size: 17px;
  }

  .brand-mark {
    width: 50px;
    height: 50px;
  }

  .logo-image {
    max-width: 44px;
    max-height: 44px;
  }

  .mobile-menu-content {
    width: min(312px, 90vw);
    padding-left: 14px;
    padding-right: 14px;
  }

  .mobile-menu-close {
    width: 38px;
    height: 38px;
    border-radius: 12px;
  }

  .mobile-nav-item + .mobile-nav-item {
    margin-top: 10px;
  }

  .mobile-nav-link {
    min-height: 54px;
  }
}
</style>
